import service from '@/store/services/settings/activities-service';

const state = {
    list: {},
    activity1: {},
    meta: {},
    url:null
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, activity1) => {
        state.activity1 = activity1;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    },
    SET_URL: (state, url) => {
        state.url = url;
    }
};

const actions = {
    list ({ commit, dispatch }, params) {
        return service.list(params)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },

    get ({ commit, dispatch }, params) {
        return service.get(params)
            .then(activity1 => {
                commit('SET_RESOURCE', activity1);
            });
    },
    show ({ commit, dispatch }, params) {
        return service.show(params)
            .then(activity1 => {
                commit('SET_RESOURCE', activity1);
            });
    },
    add ({ commit, dispatch }, params) {
        return service.add(params)
            .then((activity1) => {
                commit('SET_RESOURCE', activity1);
            });
    },

    update ({ commit, dispatch }, params) {
        return service.update(params)
            .then((activity1) => {
                commit('SET_RESOURCE', activity1);
            });
    },

    destroy ({ commit, dispatch }, params) {
        return service.destroy(params);
    },
    detachSkill({ commit }, { activityId, skillId }) {
        return service.detachSkill(activityId, skillId);
    },
    skills ({ commit, dispatch }, { activity, params = {} }) {
        return service.skills(activity, params)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },
};
const getters = {
    list: state => state.list,
    listTotal: state => state.meta.page.total,
    activity1: state => state.activity1,
    url: state => state.url,
};

const activities = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default activities;
